import styled from "@emotion/styled";

export const ModalHeader = styled.div`
  display: flex;
  padding: 0 24px 0 20px;
  align-items: center;
  height: 70px;
  border-bottom: 2px solid var(--alias-color-line-normal);
  gap: 12px;
  position: relative;
  margin-bottom: 20px;
`;

export const ModalSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 24px;
  margin-bottom: 40px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InfoContainer = styled.div`
  display: flex;
  padding: 16px;
  gap: 8px;
  align-items: center;
  border-radius: 8px;
  background-color: var(--global-color-blue-98);
`;

export const InviteInput = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TableIndex = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  background-color: var(--component-color-fill-alternative);
  border-radius: 12px;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  display: flex;
`;

export const ErrorContainer = styled.div`
  display: flex;
  gap: 6px;
`;

export const CountContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-left: auto;
`;

export const TableContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 240px;
  overflow-y: auto;
  z-index: 1;
`;
